(function Module() {
	'use strict';
	mySynch.controller('PublishedReportController', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'F360Service',
		'AuditService',
		'ApiFactory',
		'CookieFactory',
		'F360Constant',
		'F360ChartService',
		'$location',
		'$filter',
		'$window',
		'ViewAuthorizationFactory',
		'MySynchFactory',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		function PublishedReportController($s,$rootScope,$interval,$q, f360Service, auditService,api,cookies,constant, ChartService, $location,$filter,$window,viewAuth,MSF, perfMetricSvc, perfContextSvc, log) {
			window.scrollTo(0, 0);
			
		    self.auditId = auditService.getAuditId($location.url());
			$s.breadcrumbs = [];
			$s.lastBreadcrumbs = {};

			$s.codeFile = [];
	
			$s.auditApiVersion;
			
			$s.currentAuditApiVersion;

			$s.performanceContext = null;

			


			$s.$on("$destroy", function() {
		
			});
			

			MSF.ready(function onMsfReady() {
				perfMetricSvc.startTiming('Page:PublishedReport:Render');
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId',null));
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				var currentAuditApiVersionJsonArray =  JSON.parse(_.get(_.find($s.codeFile,{codeType: "CURRENTAPIVERSIONS",code:"AUDIT"}),'detailsJson'));
				$s.currentAuditApiVersion = _.get(currentAuditApiVersionJsonArray[0],'value');
				perfMetricSvc.startTiming("Page:PublishedReport:AuditServiceGetListByHerdId:Request");
				auditService.getListByHerdId($s.performanceContext, function(err, auditListData){
					perfMetricSvc.endTiming("Page:PublishedReport:AuditServiceGetListByHerdId:Request", $s.performanceContext);

					var auditData = _.find(auditListData,{AuditId: self.auditId});
	
					$s.auditApiVersion = _.get(auditData,'ApiVersion',$s.currentAuditApiVersion);
					perfMetricSvc.endTiming("page",'Page:PublishedReport:Render', $s.performanceContext);
				
					});
				
			
			});
		}
	]);
})();
